import { UserRoleSchema } from "@redotech/redo-model/user-role";
import * as z from "zod/v4";

export const getUserRolesOnTeam = {
  name: "getUserRolesOnTeam" as const,
  input: z.null(),
  output: z.object({ userRoles: z.array(UserRoleSchema) }),
};
